import { render, staticRenderFns } from "./otherBindPhone.vue?vue&type=template&id=c1f20c4e&"
import script from "./otherBindPhone.vue?vue&type=script&lang=js&"
export * from "./otherBindPhone.vue?vue&type=script&lang=js&"
import style0 from "./otherBindPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports